var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL2Mp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3171_4424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 60,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 0L61.3334 32L32.0001 64L2.66675 32L32.0001 0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3171_4424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32L22.6667 32H0V0Z",
    fill: "#5391FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32H22.6667L32 64H0V32Z",
    fill: "#2F6CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 0H64.0001V32H22.6667L32.0001 0Z",
    fill: "#2F76F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 32H64.0001V64H32.0001L22.6667 32Z",
    fill: "#1D47B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2Mp);
export default __webpack_public_path__ + "static/media/L2MP.b2505117d3c3674e91c32d266b6327b2.svg";
export { ForwardRef as ReactComponent };